import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useClientBilling = (teamId: string | undefined) => {
	return useQuery({
		queryKey: ["partner", "clients", teamId, "billing"],
		queryFn: () => partnerApiService.getTeamBilling(teamId as string),
		enabled: !!teamId,
	});
};
